// extracted by mini-css-extract-plugin
export var avatar = "PlayerMarketRows-module--avatar--f288a";
export var drawer = "PlayerMarketRows-module--drawer--f7f5f";
export var isSuspended = "PlayerMarketRows-module--isSuspended--90d6c";
export var outcome = "PlayerMarketRows-module--outcome--6636d";
export var outcomes = "PlayerMarketRows-module--outcomes--87e45";
export var player = "PlayerMarketRows-module--player--f756a";
export var playerMeta = "PlayerMarketRows-module--playerMeta--277b7";
export var playerName = "PlayerMarketRows-module--playerName--9a195";
export var playerRow = "PlayerMarketRows-module--playerRow--849b7";
export var players = "PlayerMarketRows-module--players--b9cf0";
export var scroll = "PlayerMarketRows-module--scroll--2917a";